import React from "react"
import Nav from "../components/nav"
import {NexagentLight, RegexWhite, AresWhite} from "../components/svgs.js"
import aresLogo from "../images/project-ares-logo-white.svg"
import regexLogo from "../images/regex-logo-color.png"
import nexagentLogo from "../images/nexagent-logo-color-white.png"
import "../css/demo.css"
import thumbnail from "../images/demo-thumbnail.png"
import demoMashup from "../videos/demo-mashup.mp4"
import Layout from "../components/layout"
import SEO from "../components/seo"
import {HandleImages} from "../components/functions"
import SimpleSlide from "../components/simple-slide"
import SimpleSlider from "../components/simple-slider"
import OnVisible from "react-on-visible"
import ActOnNew from "../components/act-on/act-on-new"



function detectMobile() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        try {
          return navigator.userAgent.match(toMatchItem);
        } catch {
          return false;
        }
    });
}

const iconSection = (<div className="learn-info-wrapper" style={{marginTop: 0}}>
  <div className="white transparent">
    <OnVisible >
      <div className="icon">

        <svg id="bg" viewBox="0 0 127.92 145.69" style={{transform: "rotate(-90deg)"}}>
          <path class="st0" d="M120.45 55.34c-5.15-6.48-12.33-11-17.55-17.37-7-8.56-7.19-19.69-12.26-29.09C84.76-2 73.53-3 65.71 6.65c-4.51 5.59-8.12 13.47-8.11 20.73C57.62 35.82 63 42.51 66 50c3.73 9.26 1.08 16-4.59 21.3-7.47 4.39-16.66 6.6-24.48 9.07-10.33 3.28-20.85 7.49-28.4 15.54-10.95 11.68-11.53 28.26-.71 38.46C14.48 142 25.66 146.22 35 145.64c18.29-1.14 25.57-16.06 37.88-26.91 7.38-6.5 16.33-10.82 25.36-14.51 7.69-3.14 16.21-5.6 22.52-11.27 10.98-9.84 8.09-27.03-.31-37.61z"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128.6 114.32">
          <g data-name="Layer 2">
            <g data-name="Layer 1" fill="none" stroke="#153643" stroke-linejoin="round" stroke-width="2">
              <rect x="1.5" y="1.5" width="125.6" height="86.15" rx="11.92"/>
              <path d="M1.5 72.3h125.6M55.83 87.8c0 15.26-16.57 16.4-16.57 16.4a1.7 1.7 0 00-1.7 1.7v5.22a1.7 1.7 0 001.7 1.7h50.09a1.7 1.7 0 001.7-1.7v-5.22a1.68 1.68 0 00-.5-1.2 1.73 1.73 0 00-1.2-.5s-16.62-.76-16.65-16.4"/>
              <circle cx="64.3" cy="37.99" r="22.33"/>
              <path d="M90.55 104.7H56.62M80.09 37.99L56.08 24.12v27.73l24.01-13.86z"/>
            </g>
          </g>
        </svg>

      </div>
      <span>
        Watch the video that sets up a threat landscape</span>
    </OnVisible>
    <div className="dashed-line"/>
    <OnVisible >
      <div className="icon">
        <svg id="bg" viewBox="0 0 127.92 145.69" style={{transform: "rotate(60deg)"}}>
          <path class="st0" d="M120.45 55.34c-5.15-6.48-12.33-11-17.55-17.37-7-8.56-7.19-19.69-12.26-29.09C84.76-2 73.53-3 65.71 6.65c-4.51 5.59-8.12 13.47-8.11 20.73C57.62 35.82 63 42.51 66 50c3.73 9.26 1.08 16-4.59 21.3-7.47 4.39-16.66 6.6-24.48 9.07-10.33 3.28-20.85 7.49-28.4 15.54-10.95 11.68-11.53 28.26-.71 38.46C14.48 142 25.66 146.22 35 145.64c18.29-1.14 25.57-16.06 37.88-26.91 7.38-6.5 16.33-10.82 25.36-14.51 7.69-3.14 16.21-5.6 22.52-11.27 10.98-9.84 8.09-27.03-.31-37.61z"/>
        </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 109.19 112.01">
            <g data-name="Layer 2">
              <g fill="none" stroke="#153643" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" data-name="Layer 1">
                <path d="M41.77 96.14a78.73 78.73 0 0018 13 1.09 1.09 0 001 0 78.16 78.16 0 0042-69.4 78.55 78.55 0 00-.57-9.47M84.87 5.85a13.9 13.9 0 01-.38-3.25 1.09 1.09 0 00-.36-.81 1.15 1.15 0 00-.85-.29 240.158 240.158 0 01-45.91 0 1.13 1.13 0 00-.84.29 1.07 1.07 0 00-.37.81 14 14 0 01-14 14 1.1 1.1 0 00-1.06.79A78.69 78.69 0 0023 67.73M27.84 24.91a71 71 0 001.73 36.24"/>
                <path d="M60.32 99.61a1.11 1.11 0 01-.57-.17 70.52 70.52 0 01-15-12.25"/>
                <g>
                  <path d="M7.43 95.44l8.9 8.89h.05L28 92.77v-.06l-8.89-8.89h-.05L7.43 95.38s-.01.04 0 .06z"/>
                  <path d="M32.38 97.16L14 78.76a1 1 0 010-1.45l4.14-4.13a1 1 0 011.44 0L38 91.58A1 1 0 0138 93l-4.13 4.13a1 1 0 01-1.49.03zM10.16 109.35l-7.4-7.41a4.1 4.1 0 01-.06-5.85 4 4 0 015.48.11l7.41 7.41a4.1 4.1 0 01.06 5.85 4 4 0 01-5.49-.11z"/>
                  <path d="M34.58 88.18L23 76.62a1 1 0 010-1.45L91.84 6.35a1 1 0 01.54-.28l14.11-2.55a1 1 0 011.19 1.19l-2.55 14.11a1 1 0 01-.28.54L36 88.18a1 1 0 01-1.42 0zM97.78 13.5L29.86 81.42M20.39 100.33l-8.95-8.96M24.58 96.14l-8.95-8.96"/>
                </g>
              </g>
            </g>
          </svg>
      </div>
      <span>
        Perform actions on a simulated secure shell terminal and virtual network remote desktop </span>
    </OnVisible >
    <div className="dashed-line"/>
    <OnVisible >
      <div className="icon">
          <svg id="bg" viewBox="0 0 127.92 145.69">
            <path class="st0" d="M120.45 55.34c-5.15-6.48-12.33-11-17.55-17.37-7-8.56-7.19-19.69-12.26-29.09C84.76-2 73.53-3 65.71 6.65c-4.51 5.59-8.12 13.47-8.11 20.73C57.62 35.82 63 42.51 66 50c3.73 9.26 1.08 16-4.59 21.3-7.47 4.39-16.66 6.6-24.48 9.07-10.33 3.28-20.85 7.49-28.4 15.54-10.95 11.68-11.53 28.26-.71 38.46C14.48 142 25.66 146.22 35 145.64c18.29-1.14 25.57-16.06 37.88-26.91 7.38-6.5 16.33-10.82 25.36-14.51 7.69-3.14 16.21-5.6 22.52-11.27 10.98-9.84 8.09-27.03-.31-37.61z"/>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108.15 108.16">
            <g data-name="Layer 2">
              <g fill="none" stroke="#153643" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" data-name="Layer 1">
                <path d="M47 76.74a6.82 6.82 0 015.41 2.66A234 234 0 0085 44.44a6.85 6.85 0 01-1.79-9.38 116.9 116.9 0 00-18.17-9c-1.37-.53-2.74-1-4.12-1.51a233.59 233.59 0 00-41.74 44.8 115.5 115.5 0 0021.47 11.77A6.85 6.85 0 0147 76.74z"/>
                <path d="M65.06 26a116.9 116.9 0 0118.17 9 6.79 6.79 0 016.51-3 114.16 114.16 0 00.14-16.43A114.16 114.16 0 0189.74 32 6.77 6.77 0 0193 33.28c1.74-2.62 3.46-5.26 5.1-8a52.15 52.15 0 00-16.46-16 234.58 234.58 0 00-20.7 15.25c1.38.47 2.75.98 4.12 1.47z"/>
                <path d="M60.94 24.53a115.08 115.08 0 00-15.19-4.18 6.84 6.84 0 01-10.63 4.47 116.25 116.25 0 00-16 44.51h0a233.59 233.59 0 0141.82-44.8zM19.15 69.38h0zM52.45 79.4a6.81 6.81 0 011.44 4.19 6.68 6.68 0 01-.32 2.06A115.25 115.25 0 0069.33 89a115.52 115.52 0 0012.78-23.93 115.53 115.53 0 005.73-19.48A6.77 6.77 0 0185 44.44 234 234 0 0152.45 79.4zM40.18 83.59a6.78 6.78 0 01.47-2.47 115.5 115.5 0 01-21.47-11.77h0a114.89 114.89 0 00-.88 23.18A52.41 52.41 0 0026.72 99q7.79-5.11 15.17-10.85a6.84 6.84 0 01-1.71-4.56z"/>
                <path d="M19.15 69.38C16 73.79 13 78.3 10.16 83a52.31 52.31 0 008.11 9.61 114.89 114.89 0 01.88-23.23zM98.06 25.32c-1.64 2.7-3.36 5.34-5.1 8a6.81 6.81 0 011.51 9.6A116.65 116.65 0 01106.64 54a116.65 116.65 0 00-12.17-11.12 6.83 6.83 0 01-5.47 2.8 6.74 6.74 0 01-1.11-.09 115.53 115.53 0 01-5.73 19.48A115.52 115.52 0 0169.33 89a114.69 114.69 0 0023.23.88A114.69 114.69 0 0169.33 89a115.55 115.55 0 01-15.13 17.64A115.55 115.55 0 0069.33 89a115.25 115.25 0 01-15.76-3.35 6.85 6.85 0 01-11.68 2.46Q34.51 93.83 26.72 99a52.55 52.55 0 0071.34-73.68z"/>
                <path d="M19.16 69.33A114.6 114.6 0 011.51 54.2a114.6 114.6 0 0017.65 15.13 116.25 116.25 0 0116-44.51 6.84 6.84 0 01-3-5.64v-.75a115.07 115.07 0 00-16.6-.15 115.07 115.07 0 0116.6.15 6.86 6.86 0 016.84-6.1 6.77 6.77 0 014 1.26A113.76 113.76 0 0154 1.52a113.76 113.76 0 00-11 12.07 6.84 6.84 0 012.9 5.59 6.45 6.45 0 01-.11 1.17 115.08 115.08 0 0115.19 4.18A234.58 234.58 0 0181.6 9.31 52.55 52.55 0 0010.16 83c2.85-4.65 5.85-9.16 9-13.57z"/>
              </g>
            </g>
          </svg>
      </div>
      <span>
        Learn how the platform works in the interactive trial</span>
    </OnVisible >
  </div>
</div>)

const data = {
  ares: {
    name: "Project Ares",
    logo: (<AresWhite/>),
    tagline: "Try",
    description: "Play an introductory scenario and learn how our gamified, cyber range training platform works.",
    link: "",
    img: "https://www.circadence.com/wp-content/uploads/2018/11/ares_splash_no_logo.jpg"
  },
  regex: {
    name: "Regexile",
    logo: regexLogo,
    tagline: "Learn the intricacies of regular expression while fighting robots to save humanity!",
    description: "A cyber Learning Game within Project Ares, Regexile builds your knowledge of regular expressions.<br/><br/>It is educational: Learn to sequence text strings to define search patterns and how meta characters can help uncover data patterns.<br/><br/>It is fun: Form the regular expression quickly – it’s the way to save your army from the enemy robots that seek to destroy you!",
    link: "https://archive.circadence.com/regexile-demo/index.html",
    img: "https://archive.circadence.com/wp-content/uploads/2019/03/regexstill.jpg"
  },
  nexagent: {
    name: "Nexagent",
    logo: nexagentLogo,
    tagline: "Investigate and solve industry specific network problems.",
    description: "An award-winning prototype learning game (not currently part of Project Ares), NexAgent teaches cyber security basics in a whole new way.<br/><br/> It is educational: Learn to understand, investigate, and solve specific network problems. Using a full function Command Line Emulator, you'll be the Agent that protects the network. <br/><br/>It is fun: Like a first-person action video game, YOU are the Network Agent.  Story based scenarios come to life inside this immersive training environment. ",
    link: "https://archive.circadence.com/mini-game-negDemo/",
    img: "https://archive.circadence.com/wp-content/uploads/2019/10/neg-splash.jpg"
  }
}

function getSiblings(element) {
  var siblings = [];
  var sibling = element.parentNode.firstChild;
  do {
    if (sibling != element) {
      siblings.push(sibling)
    }
  } while (sibling = sibling.nextElementSibling);

  return siblings;
}


class Demo extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: false,
      mobile: detectMobile()
    }
  }

  handleScroll = () => {
    var demoContainer = document.getElementById("demo-container")
    demoContainer.scrollIntoView({behavior: "smooth"});
  }

  activateSection(name) {
    Array.from(document.getElementsByClassName("alt-overlay")).forEach((elem) => {
      elem.classList.remove('active')
    })

    document.getElementById(`demo-${name}`).classList.add("active")
  }

  toggleFormPopup = () => {

    if (this.state.form) {
      document.getElementsByClassName('nl-formbox')[0].classList.remove('opened')
    } else {
      document.getElementsByClassName('nl-formbox')[0].classList.add('opened')
    }
    this.setState({
      form: !this.state.form
    })
  }

  render() {
    return (<Layout>
      <SEO title="Demos"/>
      <div className={this.state.form ? "form-popup visible" : "form-popup"} onClick={this.toggleFormPopup}>
        <div className="nl-formbox" >
          <div onClick={e => e.stopPropagation()}>
          <ActOnNew id="7663e42d-b875-408e-bdb5-0ed364649588" /></div>
        </div>
      </div>
      <div id="demo-container" className="mainContainer">
        <div id="featured-demo">
          <div className="featured-desc">
            <div className="basicFlex nowrap demo-ares-header" style={{alignItems: "center"}}>
              <img className="featured-logo" src={aresLogo} style={{margin: "20px 0 20px 0px"}}/>
            </div>
            <h4 style={{color: "var(--yellow)"}}>{data.ares.description}</h4>
            {(this.state.mobile ? <p>Demo's are compatible on desktop browsers only</p> : <button className="flat-button yellow" onClick={this.toggleFormPopup}>Play Trial</button>)}
            <a href="/faq">
              <button style={{
                  marginLeft: 15
                }} className="outlined-button yellow">FAQ</button>
            </a>
          </div>
          <div className="featured-video">
            <video controls="controls" muted="muted" src="https://player.vimeo.com/external/241897376.hd.mp4?s=ecbb3ae92f3a3a13ccf2dbb095a33385b6365ed6&profile_id=174" autoPlay="autoplay"/>
          </div>
        </div>
      </div>
      <div className="mainContainer gray" style={{paddingTop: 50}}>
        <center style={{marginBottom: 50}}>
          <h2 style={{fontWeight: 400}}>Practice Makes Perfect</h2>
          <h4>See how Project Ares delivers hands-on experience</h4>
        </center>
        {iconSection}
      </div>
      <div className="mainContainer" style={{paddingTop: 0, paddingBottom: 0}}>
        <div id="alt-header">
          <h2 style={{fontWeight: 400}}>Try More Games</h2>
        </div>
        <div id="alt-demos">
          <div className="alt-demo" style={{
              backgroundImage: `url(${data.regex.img})`
            }}>
            <div id="demo-regex" onClick={() => this.activateSection("regex")} className="alt-overlay">
              <div>
                <div className="alt-header">
                  <img src={data.regex.logo} className="alt-logo"/>
                </div>
                <div className="alt-desc">
                  <h4>{data.regex.tagline}</h4>
                  <p dangerouslySetInnerHTML={{__html: data.regex.description}}></p>
                  {(this.state.mobile ? <p>Demo's are compatible on desktop browsers only</p> : <a href={data.regex.link} target="__blank"><button className="flat-button yellow">Launch Demo</button></a>)}
                </div>
              </div>
            </div>
          </div>
          <div className="alt-demo" style={{
              backgroundImage: `url(${data.nexagent.img})`
            }}>
            <div id="demo-nexagent" onClick={() => this.activateSection("nexagent")} className="alt-overlay">
              <div>
                <div className="alt-header">
                  <img src={data.nexagent.logo} className="alt-logo"/>
                </div>
                <div className="alt-desc">
                  <h4>{data.nexagent.tagline}</h4>
                  <p dangerouslySetInnerHTML={{__html: data.nexagent.description}}></p>
                  {(this.state.mobile ? <p>Demo's are compatible on desktop browsers only</p> : <a href={data.nexagent.link} target="__blank"><button className="flat-button yellow">Launch Demo</button></a>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mainContainer deep-blue">
        <div className="centeredContainer" id="demo-footer">
          <img className="featured-logo-bottom" src={aresLogo}/>
          <div>
            <ul className="demo-list">
              <li>It's designed to support progressive learning</li>
              <li>Start wherever you need to and build up skills</li>
              <li>There are foundational cyber security learning games (yes, games!)</li>
              <li>Move up by applying concepts in realistic cyber scenario activities</li>
            </ul>
          </div>
          <div>
            <a href={data.regex.link} target="__blank">
              <button className="flat-button yellow">Play Trial</button>
            </a>
          </div>
        </div>
      </div>
    </Layout>)
  }
}

export default Demo;
